import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-120" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-121" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-122" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-123" data-mp="tyv5tcf1sfy9">🏆 </span>Offre Spéciale de Lancement
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-124" data-mp="u0xvtwg7a92z">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-125" data-mp="13x14zm9gz7zf">
            Pack ANGLAIS PRÊT™
          </span>

          <dl data-id="element-126" data-mp="2fbog46xvvghg">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-127" data-mp="2feao27oory07">
                <dt className="text-ink/80" data-id="element-128" data-mp="pjfi048iobg0">{row.label}</dt>
                <dd className="whitespace-nowrap font-bold text-brand" data-id="element-129" data-mp="uj1xylfqc5si">
                  {row.value}
                </dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-130" data-mp="zj6egbgn10iq">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-131" data-mp="13j746s96sy53">
                Valeur Totale :
              </dt>
              <dd className="whitespace-nowrap font-bold text-amber-600 line-through" data-id="element-132" data-mp="6rwk2btcnnku">
                297 USD
              </dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-133" data-mp="fsuogv7p9x3y">
            Seulement aujourd&apos;hui
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-134" data-mp="3k95m0jtrt7kt">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-135" data-mp="3o9peha3efn0m">
              🏆
            </span>
            <span className="flex items-baseline gap-1.5 font-display font-black leading-none text-brand" data-id="element-136" data-mp="veyyqji1b0y8">
              <span className="text-6xl sm:text-7xl" data-id="element-137" data-mp="qfmfs9uaae0x">27</span>
              <span className="text-lg font-bold tracking-[0.08em] sm:text-xl" data-id="element-138" data-mp="155k5wvbrxdsr">
                USD
              </span>
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-139" data-mp="106z6uz89d05w">
            <span aria-hidden="true" data-id="element-140" data-mp="cho2z8vm2pnj">💳 </span>Paiement unique · Accès à vie ·
            Aucun abonnement.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-141" data-mp="7jwb2euyv3jc" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-142" data-mp="li2rsi7samvs">
            Téléchargement Instantané · Paiement Unique · Accès à Vie ·
            Garantie de 7 Jours
          </p>
        </div>
      </div>
    </section>;
}